import { ChevronRight } from "lucide-react";
import { useRef } from "react";

import { Section } from "components/landing/layout/Section";
import { Button } from "components/products/muggleTestV0/components/ui/button";
import { CLOSING_CTA } from "content/landing";
import { trackCtaClick, trackSignupStarted, useSectionViewTracking } from "lib/analytics";
import type { ClosingCtaSectionProps } from "types/landing/landing.types";

/** Full-width closing call-to-action section rendered between FAQ and footer. */
export function ClosingCtaSection({ onSignup }: ClosingCtaSectionProps) {
  const sectionRef = useRef<HTMLDivElement>(null);
  useSectionViewTracking("contact", sectionRef);

  return (
    <Section id="closing-cta" className="bg-background py-16 sm:py-24">
      <div ref={sectionRef} className="mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">{CLOSING_CTA.headline}</h2>
        <p className="mb-8 text-lg text-muted-foreground">{CLOSING_CTA.subheadline}</p>
        <Button
          size="lg"
          className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
          onClick={() => {
            trackCtaClick("closing_cta");
            trackSignupStarted("closing_cta");
            onSignup();
          }}
        >
          {CLOSING_CTA.primaryCta}
          <ChevronRight className="h-4 w-4" />
        </Button>
        <p className="mt-4 text-xs text-muted-foreground">{CLOSING_CTA.trustLine}</p>
      </div>
    </Section>
  );
}
